import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as PageStore from "src/app/Store/PageStore/Page.Actions";
import { APICallingService } from './model/APICallingService';
import { AppSettings, IAppSettings } from './model/application-settings';
import { UserSettings } from './model/UserSettings';
import * as AppLoadingSettings from './Store/Appsettings/AppLoadingSettings';
import Swal from 'sweetalert2';
import { Cart } from './model/Cart';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  //title = 'web-food-online-order';
  
constructor(public appSettings:AppSettings,public router:Router,private store: Store<any>, private storeAppSettings:AppSettings,
  private apiCall:APICallingService,private title:Title)
  {
    debugger;
  //   let res=window.location.href.split('/#/');
  //   if(res.length>0)
  //   {
  //   if(res[1]=='online-order/home' || res[1]==''  || res[1]=='online-order')
  //   {
  // this.apiCall.GetApplicationSettings(res[0]).subscribe(
  //   (res:any) => 
  //   {
  //     debugger;
  //     if(res.objCompanySettingsdomain.length>0 )
  //     {
  //     this.storeSettings=   this.appSettings.loadSettings();

  //     this.storeSettings=Object.assign({}, res.objCompanySettingsdomain[0])

  //     this.storeSettings.logo= AppLoadingSettings.DocumentPath+this.storeSettings.logo;
  //     this.storeSettings.headerimage= AppLoadingSettings.DocumentPath+this.storeSettings.headerimage;
  //     this.storeSettings.viewName="AppSettings";
  //     this.store.dispatch(new  PageStore.OpenPage(this.storeSettings));
  //     }
  //   });
  //   }
  // }
      this.storeSettings=this.appSettings.loadSettings();
  }
 
  // favIcon: HTMLLinkElement = document.querySelector('#appIcon');

ngOnInit()
{
  debugger;
  this.storeUserSettings= new UserSettings();
  var result = (this.store as any).source['value']['MSFOO'].filter((x:any) => { return x.viewName == "UserDetails"; });
  if (result.length > 0) {
    this.storeUserSettings=( Object.assign({},result[0] ));
   // this.title.setTitle(this.storeSettings.companyName+" "+('Online Order'));
  }
  // else{
  //   this.title.setTitle("web-food-online-order");
  //   }
    if( this.storeSettings.companyName!="") {
      this.title.setTitle(this.storeSettings.companyName+" "+('Online Order'));
    }
    else{
    this.title.setTitle("web-food-online-order");
    }
 // this.favIcon.href = this.storeSettings.logo;
  $("#favicon").attr("href",this.storeSettings.logo);
  this.storeSettings= this.storeAppSettings.loadSettings();
}

editProfile(){
  this.router.navigateByUrl('editprofile');
}
orders(){
  this.router.navigateByUrl('myorders');
}

logoutClick()
{
  let storeUserSettings=new UserSettings;
  this.storeUserSettings.viewName="UserDetails";
  this.store.dispatch(new  PageStore.OpenPage(storeUserSettings));
  this.router.navigateByUrl('/login');
}
selectedBranchName:any='';
locatonClick(selectedBranch:any)
{
  debugger;

  this.storeSettings= this. storeAppSettings.loadSettings();
  this.storeSettings.selectedBranch=selectedBranch;
  this.store.dispatch(new  PageStore.OpenPage(this.storeSettings));
  this.selectedBranchName=selectedBranch.Name;
  

 this.router.navigate(['/online-order/home'])
 .then(() => {
   window.location.reload();
 });

// this.store.dispatch(new  PageStore.OpenPage(selectedLocation));
}
getUser()
{
  let uName=(((this.storeUserSettings!=null && typeof(this.storeUserSettings)!='undefined') && typeof(this.storeUserSettings.FirstName)!='undefined'  && (this.storeUserSettings.FirstName)!='') ?  this.storeUserSettings.FirstName:'Guest')+  ((typeof(this.storeUserSettings.LastName)!='undefined' && this.storeUserSettings.LastName!='')? (this.storeUserSettings.LastName):'');
  // let uName=(((this.storeUserSettings!=null && typeof(this.storeUserSettings)!='undefined') && typeof(this.storeUserSettings.FirstName)!='undefined'  && (this.storeUserSettings.FirstName)!='') ?  this.storeUserSettings.FirstName:'Guest')+  ((typeof(this.storeUserSettings.LastName)!='undefined' && this.storeUserSettings.LastName!='')? (+''+this.storeUserSettings.LastName):'');
  return uName
}

productSearchClick()
{
  this.router.navigateByUrl("/online-order/productsearch");
}
storeSettings:IAppSettings=
{
faxUserId:'',
      faxPassword:'',

  companyName:'',
    theamColorCode:'#ea0029',
    headerColorCode: '#000',
    headerimage: '../../assets/img/trending1.png',
    loginBackgroundImage:'../../assets/img/logo_web.png',
      loginImage:'../../assets/img/logo_web.png',
    dangerColorCode: '#dc3545',
    successColorCode: '#28a745',
    logo: '../../assets/img/logo_web.png',
    paymentGateway:'',
    key:'',
    selectedBranch:'',
    apiLoginId:'',
    orderEmail:'',
    adminUrl:'',
    orderUrl:'',
    viewName:'AppSettings',
    apiCallingUrl:'',
    fontFamily:'prompt,sans-serif',
    domainName:'',
    fax:'',
    projectId:'',
    
    keyNo:'',
    noOfBranches:0,
    addClover:'',
    cloverAccessToken:'',
    cloverAuthToken:'',
    cloverMerchantId:'',
    cloverEmployeeID:'',
    cloverTenderId:'',
    currency:'',
    transactionkey:'',
    
};
loginClick()
{
  this.router.navigateByUrl('/login');
}
getDocUrl()
{
debugger;
 return  AppLoadingSettings.DocumentPath;
}
cart:Cart={   
  viewName:"Cart",
  lstCartList:[],
  PakageName:"",
  PakageDays:0,
 BranchId:0,};
locationChange()
{
  Swal.fire({
    title: 'Are you sure',
    text: 'Cart items will clear. Do you want to change location? ',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      debugger;
      this.cart=new Cart();

this.store.dispatch(new  PageStore.OpenPage(this.cart));

this.router.navigateByUrl('/branches');

    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire(
        'Cancelled',
        '',
        'error'
      )};
  });
}

lstBranch:any=[];
storeUserSettings:any;
  ngDoCheck()
  { 
try
{
    this.storeSettings= this. storeAppSettings.loadSettings();
    if((+this.storeSettings.selectedBranch.IsTodayHoliday)>0)
    {
      this.router.navigateByUrl('/holidaypage');
    }
  this.selectedBranchName=this.storeSettings.selectedBranch.Name;

  }catch(e)
  {

  }

    this.storeUserSettings=new  UserSettings();
    var result = (this.store as any).source['value']['MSFOO'].filter((x:any) => { return x.viewName == "UserDetails"; });
    if (result.length > 0) {


      this.storeUserSettings=( Object.assign({},result[0] ));

     

    }

    try{
  //  debugger;
    let storeBranch = (this.store as any).source['value']['MSFOO'].filter((x:any) => {
    return x.viewName == 'Branch';
    
  });
  if( storeBranch.length > 0) {

    this.lstBranch=Object.assign([],  storeBranch[0].lstBraches);

  //this.lstDeliveryLocation=Object.assign([], storeBranch.selectedBranch.lstDeliveryLocation) ;
    
  }
    }catch(e)
    {

    }


  // let storSelectedLocation = (this.store as any).source['value']['MSFOO'].filter((x:any) => {
  //   return x.viewName == 'Branch';
    
  // });
  // if( storSelectedLocation.length > 0) {
  //   this.selectedLocationName=storSelectedLocation.LocationName;
  // }

 // this.storeSettings= this. storeAppSettings.loadSettings();

  // /this.storeSettings.selectedBranch=selectedBranch;
  }

  cartClick(){
    this.router.navigateByUrl('online-order/checkout');
  }

  ngAfterViewInit(){
    this.getAllBranchDetails();
  }

  lstBraches:any=[];
  getAllBranchDetails() 
  {
  debugger;
    this.lstBraches=[];
    this.apiCall.DBCalling("getBranches","","","","").subscribe(
      (res:any) => {
        if(res.tasks[0].length>0 )
        {
           debugger;
          let lstBraches=res.tasks[0];
          for(let i=0;i<lstBraches.length;i++)
          {
            if(i<(+this.storeSettings.noOfBranches))
            {
              this.lstBraches.push(lstBraches[i])
            }
          }
          for(let i=0;i<this.lstBraches.length;i++)
          {
            if(this.lstBraches[i].lstbranchTimePropL!=null && typeof(this.lstBraches[i].lstbranchTimePropL)!=undefined)
            {
            var resData=((this.lstBraches[i].lstbranchTimePropL).replace(/\n/g, "")).replace(/'/g,"\"");
            this.lstBraches[i].lstbranchTimePropL=JSON.parse(resData);
            }
            else{
            this.lstBraches[i].lstbranchTimePropL = Object.assign([{}],{BranchID:"0",DeleteFlag: "0",From: "",ID: "",ModifiedBy: "",ModifiedDate: "",Show: "true",To:"",WeekName:""})
          }
            if(this.lstBraches[i].lstDeliveryLocation!=null && typeof(this.lstBraches[i].lstDeliveryLocation)!=undefined)
            {
            var resData=((this.lstBraches[i].lstDeliveryLocation).replace(/\n/g, "")).replace(/'/g,"\"");
            this.lstBraches[i].lstDeliveryLocation=JSON.parse(resData);
            }
            else{
              this.lstBraches[i].lstDeliveryLocation = Object.assign([{}],{BranchID:"0",DeleteFlag: "0",Charges: "",ID: "",ModifiedBy: "",ModifiedDate: "",Show: "true",LocationID:"",LocationName:"",
              Table:"DeliveryLocation",ZipCode:""})
            } 
          }
          this.lstBraches = this.lstBraches.filter((x:any)=>x.BranchID === this.storeSettings.selectedBranch.BranchID);
           let selectedBranch = this.lstBraches[0];
          if(selectedBranch.IsTodayHoliday >0){
            this.router.navigateByUrl('/holidaypage');
          }
          else{
          // this.router.navigateByUrl('/online-order/home');
          this.store.dispatch(new  PageStore.OpenPage({selectedBranch:selectedBranch,viewName:'selectedBranch'}));
          this.storeSettings.selectedBranch=selectedBranch;
          this.store.dispatch(new  PageStore.OpenPage(this.storeSettings));
          }
        }
      },
      (err:any) => {
      }
    );
  }
}
